import {Directive, ElementRef, Input, Renderer} from '@angular/core';
import {PermsService} from '../../../services/utils/perms.service';
import {PermissionConfiguration} from '../../../models/permission.model';

@Directive({
  selector: '[CheckPermissions]'
})
export class CheckPermissionsDirective{

  @Input('CheckPermissions') conf: PermissionConfiguration;

  constructor (
    public renderer: Renderer,
    public elementRef: ElementRef,
    private srvPerms: PermsService
  ) { }
  applyPerms() {
    this.srvPerms.check(this.conf).subscribe(res => {
      if (res) {
        console.log("PERMISSION REMOVE ELEMENT", res, this.elementRef, this.elementRef.nativeElement);
        this.elementRef.nativeElement.remove();
      }
    });
  }

  ngAfterViewInit(): void {
    console.log(this.conf);
    if (!this.conf) {
      return;
    }

    if (!this.srvPerms.permissions[this.conf.ms_base]) {
      this.srvPerms.get(this.conf.ms_base).subscribe(() => this.applyPerms())
    } else {
      this.applyPerms();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/directives/checkPermissions.directive.ts